export default __webpack_public_path__ + "static/media/feb5.b122e4fd.jpg";